// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__GP4pV","right":"styles_right__2KTnf"};